var chunkToChildrenMap = {
	"src_app_login_login_module_ts": [
		"src_app_recuperacao-senha_recuperacao-senha_module_ts"
	],
	"src_app_purchase_purchase_module_ts": [
		"src_app_pix-modal_pix-modal_module_ts"
	],
	"src_app_my-programs-coach_my-programs-coach_module_ts": [
		"src_app_popover-programas_popover-programas_module_ts"
	],
	"node_modules_rxjs__esm2015_internal_operators_timeout_js-src_app_login-parceiro_login-parceir-98d185": [
		"src_app_recuperacao-senha_recuperacao-senha_module_ts"
	],
	"src_app_programa-treino_programa-treino_module_ts": [
		"common",
		"default-src_app_treino-programa-detalhe_treino-programa-detalhe_module_ts"
	],
	"src_app_novo-treino-programa_novo-treino-programa_module_ts": [
		"src_app_biblioteca-modal_biblioteca-modal_module_ts",
		"src_app_popover-templates_popover-templates_module_ts",
		"src_app_selecao-template-modal_selecao-template-modal_module_ts"
	],
	"src_app_api_programas_service_ts-src_app_components_alert_index_ts": [
		"common"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));